'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  function h(c, b) {
    if (!(c instanceof b)) throw new TypeError("Cannot call a class as a function");
  }

  function v(c, b) {
    for (var e = 0; e < b.length; e++) {
      var a = b[e];
      a.enumerable = a.enumerable || !1;
      a.configurable = !0;
      "value" in a && (a.writable = !0);
      Object.defineProperty(c, a.key, a);
    }
  }

  function f(c, b, e) {
    b && v(c.prototype, b);
    e && v(c, e);
    return c;
  }

  function l(c, b) {
    if ("function" !== typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
    c.prototype = Object.create(b && b.prototype, {
      constructor: {
        value: c,
        writable: !0,
        configurable: !0
      }
    });
    b && r(c, b);
  }

  function q(c) {
    q = Object.setPrototypeOf ? Object.getPrototypeOf : function (b) {
      return b.__proto__ || Object.getPrototypeOf(b);
    };
    return q(c);
  }

  function r(c, b) {
    r = Object.setPrototypeOf || function (b, a) {
      b.__proto__ = a;
      return b;
    };

    return r(c, b);
  }

  function w() {
    if ("undefined" === typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
    if ("function" === typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (c) {
      return !1;
    }
  }

  function k(c) {
    if (void 0 === c) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return c;
  }

  function m(c) {
    var b = w();
    return function () {
      var e = q(c);

      if (b) {
        var a = q(this).constructor;
        e = Reflect.construct(e, arguments, a);
      } else e = e.apply(this, arguments);

      e = !e || "object" !== _typeof(e) && "function" !== typeof e ? k(this) : e;
      return e;
    };
  }

  function p(c) {
    var b = Array.isArray(c) ? t(c) : void 0;
    b || (b = "undefined" !== typeof Symbol && Symbol.iterator in Object(c) ? Array.from(c) : void 0);
    if (!b) a: {
      if (c) {
        if ("string" === typeof c) {
          b = t(c, void 0);
          break a;
        }

        b = Object.prototype.toString.call(c).slice(8, -1);
        "Object" === b && c.constructor && (b = c.constructor.name);

        if ("Map" === b || "Set" === b) {
          b = Array.from(c);
          break a;
        }

        if ("Arguments" === b || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(b)) {
          b = t(c, void 0);
          break a;
        }
      }

      b = void 0;
    }
    if (!(c = b)) throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    return c;
  }

  function t(c, b) {
    if (null == b || b > c.length) b = c.length;

    for (var e = 0, a = Array(b); e < b; e++) {
      a[e] = c[e];
    }

    return a;
  }

  var x = function () {
    function c() {
      h(this, c);
      this.handlers = {};
    }

    f(c, [{
      key: "addEventListener",
      value: function value() {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document,
            c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "click";
        this.handlers[c] = {
          func: 2 < arguments.length ? arguments[2] : void 0,
          target: b
        };
        var a = c.split(".")[0];
        b.addEventListener(a, this.handlers[c].func);
      }
    }, {
      key: "removeEventListener",
      value: function value() {
        var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "click",
            c = b.split(".")[0],
            a = this.handlers[b];
        a.target.removeEventListener(c, a.func);
        delete this.handlers[b];
      }
    }, {
      key: "removeAll",
      value: function value() {
        for (var b in this.handlers) {
          this.removeEventListener(b);
        }
      }
    }]);
    return c;
  }(),
      y = function y() {
    return "".concat(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "id", "-").concat(Math.random().toString(36).substr(2, 8));
  },
      g = function () {
    function c() {
      h(this, c);
      this.events = new x();

      this.callback = function () {};

      this.updateInstanceId();
    }

    f(c, [{
      key: "eventHandler",
      value: function value(b, c) {
        var a = this,
            n = c.share_url,
            d = c.windowTitle,
            e = c.windowWidth,
            h = c.windowHeight;
        b.preventDefault();
        c = Math.round((window.outerHeight || window.document.documentElement.offsetHeight) / 2 - h / 2);
        var f = Math.round((window.outerWidth || window.document.documentElement.offsetWidth) / 2 - e / 2);
        e = "width=".concat(e, ",height=").concat(h);
        c = "left=".concat(f, ",top=").concat(c);
        var g = "".concat(e, ",").concat(c, ",location=no,toolbar=no,menubar=no"),
            k = window.open(n, d, g),
            l = setInterval(function () {
          k.closed && (a.callback(b, {
            share_url: n,
            windowTitle: d,
            windowOptions: g
          }, k), clearInterval(l));
        }, 10);
        return k;
      }
    }, {
      key: "setShareCallback",
      value: function value(b) {
        this.callback = b;
      }
    }, {
      key: "createEvents",
      value: function value(b) {
        var c = this;
        p(b).forEach(function (a) {
          var b = c.getPreparedData(a);
          c.events.addEventListener(a, "click.".concat(c.instanceId), function (a) {
            return c.eventHandler.call(c, a, b);
          });
        });
      }
    }, {
      key: "getInstance",
      value: function value() {
        "function" === typeof this.shareWindow && this.shareWindow();
        "function" === typeof this.getCounter && this.getCounter();
        return this;
      }
    }, {
      key: "updateInstanceId",
      value: function value() {
        this.instanceId = y();
      }
    }, {
      key: "reNewInstance",
      value: function value() {
        this.events.removeAll();
        this.updateInstanceId();
        return this.getInstance();
      }
    }]);
    return c;
  }(),
      u = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('link[rel="apple-touch-icon"]');
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.title = encodeURIComponent(n);
      c.image = d ? encodeURIComponent(d.href) : "";
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            d = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        a = a.dataset.image ? encodeURIComponent(a.dataset.image) : this.image;
        b = "https://vk.com/share.php?url=".concat(b, "&title=").concat(d, "&image=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="vkontakte"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = document.querySelectorAll('[data-counter="vkontakte"]'),
            d = "https://vk.com/share.php?act=count&index=1&url=".concat(this.url);
        window.VK = Object.assign({}, {
          Share: {}
        }, window.VK);
        0 < b.length && (window.VK.Share.count = function (n, d) {
          p(b).forEach(function (a) {
            a.innerHTML = d;
          });
          null !== a.parentNode && a.parentNode.removeChild(a);
        }, a.src = d, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      z = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(n);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://facebook.com/sharer/sharer.php?u=".concat(b, "&t=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="facebook"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = ("goodshare_" + Math.random()).replace(".", ""),
            d = document.querySelectorAll('[data-counter="facebook"]'),
            c = "https://graph.facebook.com/?id=".concat(this.url, "&callback=").concat(b);
        0 < d.length && (window[b] = function (b) {
          p(d).forEach(function (a) {
            a.innerHTML = b.share ? b.share.share_count : 0;
          });
          null !== a.parentNode && a.parentNode.removeChild(a);
        }, a.src = c, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      A = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(n);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://connect.ok.ru/offer?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="odnoklassniki"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = document.querySelectorAll('[data-counter="odnoklassniki"]'),
            d = "https://connect.ok.ru/dk?st.cmd=extLike&uid=1&ref=".concat(this.url);
        window.ODKL = {};
        0 < b.length && (window.ODKL.updateCount = function (n, d) {
          p(b).forEach(function (a) {
            a.innerHTML = d;
          });
          null !== a.parentNode && a.parentNode.removeChild(a);
        }, a.src = d, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      B = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]'),
          c = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : document.querySelector('link[rel="apple-touch-icon"]');
      h(this, b);
      var f = e.call(this);
      f.url = encodeURIComponent(a);
      f.title = encodeURIComponent(n);
      f.description = d ? encodeURIComponent(d.content) : "";
      f.image = c ? encodeURIComponent(c.href) : "";
      f.createEvents = f.createEvents.bind(k(f));
      return f;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            d = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title,
            c = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        a = a.dataset.image ? encodeURIComponent(a.dataset.image) : this.image;
        b = "https://connect.mail.ru/share?url=".concat(b, "&title=").concat(d, "&description=").concat(c, "&imageurl=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="moimir"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = encodeURIComponent(this.url.replace(/^.*?:\/\//, "")),
            d = ("goodshare_" + Math.random()).replace(".", ""),
            c = document.querySelectorAll('[data-counter="moimir"]');
        0 < c.length && (window[d] = function (b) {
          p(c).forEach(function (a) {
            a.innerHTML = b.share_mm;
          });
          null !== a.parentNode && a.parentNode.removeChild(a);
        }, a.src = "https://appsmail.ru/share/count/" + b + "?callback=" + d, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      C = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]');
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.title = encodeURIComponent(n);
      c.description = d ? encodeURIComponent(d.content) : "";
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            d = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        a = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        b = "https://www.tumblr.com/widgets/share/tool?canonicalUrl=".concat(b, "&title=").concat(d, "&caption=").concat(a, "&posttype=link");
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="tumblr"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = ("goodshare_" + Math.random()).replace(".", ""),
            d = document.querySelectorAll('[data-counter="tumblr"]'),
            c = "https://api.tumblr.com/v2/share/stats?url=".concat(this.url, "&callback=").concat(b);
        0 < d.length && (window[b] = function (b) {
          p(d).forEach(function (a) {
            a.innerHTML = b.response.note_count;
          });
          null !== a.parentNode && a.parentNode.removeChild(a);
        }, a.src = c, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      D = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.querySelector('meta[name="description"]'),
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('link[rel="apple-touch-icon"]');
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.description = n ? encodeURIComponent(n.content) : "";
      c.image = d ? encodeURIComponent(d.href) : "";
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            d = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        a = a.dataset.image ? encodeURIComponent(a.dataset.image) : this.image;
        b = "https://www.pinterest.com/pin/create/button/?url=".concat(b, "&description=").concat(d, "&media=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="pinterest"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = ("goodshare_" + Math.random()).replace(".", ""),
            d = document.querySelectorAll('[data-counter="pinterest"]'),
            c = "https://api.pinterest.com/v1/urls/count.json?url=".concat(this.url, "&callback=").concat(b);
        0 < d.length && (window[b] = function (b) {
          p(d).forEach(function (a) {
            a.innerHTML = 0 < b.length ? b.count : 0;
          });
          null !== a.parentNode && a.parentNode.removeChild(a);
        }, a.src = c, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      E = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.title = encodeURIComponent(n);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://reddit.com/submit?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="reddit"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      F = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.title = encodeURIComponent(n);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://buffer.com/add?url=".concat(b, "&text=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="buffer"]');
        return this.createEvents(a);
      }
    }, {
      key: "getCounter",
      value: function value() {
        var a = document.createElement("script"),
            b = ("goodshare_" + Math.random()).replace(".", ""),
            c = document.querySelectorAll('[data-counter="buffer"]'),
            e = "https://api.bufferapp.com/1/links/shares.json?url=".concat(this.url, "&callback=").concat(b);
        0 < c.length && (window[b] = function (b) {
          p(c).forEach(function (a) {
            a.innerHTML = b ? b.shares : 0;
          });
          a.parentNode.removeChild(a);
        }, a.src = e, document.body.appendChild(a));
      }
    }]);
    return b;
  }(g),
      G = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://twitter.com/share?url=".concat(b, "&text=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="twitter"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      H = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://livejournal.com/update.bml?event=".concat(b, "&subject=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="livejournal"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      I = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]');
      h(this, b);
      var f = e.call(this);
      f.url = encodeURIComponent(a);
      f.title = encodeURIComponent(c);
      f.description = d ? encodeURIComponent(d.content) : "";
      f.createEvents = f.createEvents.bind(k(f));
      return f;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            c = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        a = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        b = "https://www.linkedin.com/shareArticle?url=".concat(b, "&text=").concat(c, "&summary=").concat(a, "&mini=true");
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="linkedin"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      J = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]');
      h(this, b);
      var f = e.call(this);
      f.url = encodeURIComponent(a);
      f.title = encodeURIComponent(c);
      f.description = d ? encodeURIComponent(d.content) : "";
      f.createEvents = f.createEvents.bind(k(f));
      return f;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            c = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        a = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        b = "https://www.evernote.com/clip.action?url=".concat(b, "&title=").concat(c, "&body=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="evernote"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      K = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://del.icio.us/save?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="delicious"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      L = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://share.flipboard.com/bookmarklet/popout?ext=sharethis&title=".concat(a, "&url=").concat(b, "&v=2");
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="flipboard"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      M = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "https://mix.com/mixit?su=submit&url=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="mix"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      N = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "https://www.meneame.net/submit?url=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="meneame"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      O = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://www.blogger.com/blog-this.g?u=".concat(b, "&n=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="blogger"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      P = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://getpocket.com/save?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="pocket"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      Q = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://www.instapaper.com/edit?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="instapaper"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      R = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://digg.com/submit?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="digg"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      S = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "http://www.liveinternet.ru/journal_post.php?action=n_add&cnurl=".concat(b, "&cntitle=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="liveinternet"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      T = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]');
      h(this, b);
      var f = e.call(this);
      f.url = encodeURIComponent(a);
      f.title = encodeURIComponent(c);
      f.description = d ? encodeURIComponent(d.content) : "";
      f.createEvents = f.createEvents.bind(k(f));
      return f;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            c = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        a = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        b = "https://surfingbird.ru/share?url=".concat(b, "&title=").concat(c, "&description=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="surfingbird"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      U = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "https://www.xing.com/spi/shares/new?url=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="xing"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      V = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]'),
          f = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : document.querySelector('link[rel="apple-touch-icon"]');
      h(this, b);
      var g = e.call(this);
      g.url = encodeURIComponent(a);
      g.title = encodeURIComponent(c);
      g.description = d ? encodeURIComponent(d.content) : "";
      g.image = f ? encodeURIComponent(f.href) : "";
      g.createEvents = g.createEvents.bind(k(g));
      return g;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            c = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title,
            e = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        a = a.dataset.image ? encodeURIComponent(a.dataset.image) : this.image;
        b = "https://wordpress.com/wp-admin/press-this.php?u=".concat(b, "&t=").concat(c, "&s=").concat(e, "&i=").concat(a, "&v=2");
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="wordpress"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      W = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title,
          d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : document.querySelector('meta[name="description"]');
      h(this, b);
      var f = e.call(this);
      f.url = encodeURIComponent(a);
      f.title = encodeURIComponent(c);
      f.description = d ? encodeURIComponent(d.content) : "";
      f.createEvents = f.createEvents.bind(k(f));
      return f;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url,
            c = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        a = a.dataset.description ? encodeURIComponent(a.dataset.description) : this.description;
        b = "https://cang.baidu.com/do/add?iu=".concat(b, "&it=").concat(c, "&dc=").concat(a, "&fr=ien");
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="baidu"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      X = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "http://share.renren.com/share/buttonshare.do?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="renren"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      Y = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href,
          c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document.title;
      h(this, b);
      var d = e.call(this);
      d.url = encodeURIComponent(a);
      d.title = encodeURIComponent(c);
      d.createEvents = d.createEvents.bind(k(d));
      return d;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.title ? encodeURIComponent(a.dataset.title) : this.title;
        b = "https://service.weibo.com/share/share.php?url=".concat(b, "&title=").concat(a);
        return {
          callback: this.callback,
          share_url: b,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="weibo"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      Z = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "sms:?&body=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="sms"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      aa = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "https://web.skype.com/share?".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="skype"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      ba = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        var b = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = a.dataset.rhash ? a.dataset.rhash : null;
        var c = "https://t.me/share/url?url=".concat(b);
        null !== a && (c = "https://t.me/iv?url=".concat(b, "&rhash=").concat(a));
        return {
          callback: this.callback,
          share_url: c,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="telegram"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      ca = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "viber://forward?text=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="viber"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      da = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "https://api.whatsapp.com/send?text=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="whatsapp"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g),
      ea = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "https://chart.apis.google.com/chart?cht=qr&chs=196x196&chld=Q%7C0&chl=".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="wechat"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g);

  g = function (c) {
    function b() {
      var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : document.location.href;
      h(this, b);
      var c = e.call(this);
      c.url = encodeURIComponent(a);
      c.createEvents = c.createEvents.bind(k(c));
      return c;
    }

    l(b, c);
    var e = m(b);
    f(b, [{
      key: "getPreparedData",
      value: function value(a) {
        a = a.dataset.url ? encodeURIComponent(a.dataset.url) : this.url;
        a = "line://msg/text/".concat(a);
        return {
          callback: this.callback,
          share_url: a,
          windowTitle: "Share this",
          windowWidth: 640,
          windowHeight: 480
        };
      }
    }, {
      key: "shareWindow",
      value: function value() {
        var a = document.querySelectorAll('[data-social="line"]');
        return this.createEvents(a);
      }
    }]);
    return b;
  }(g);

  var fa = [u, z, A, B, I, C, D, E, F, G, H, J, K, L, P, M, N, O, Q, R, S, T, U, V, W, X, Y, Z, aa, ba, ca, da, ea, g];

  u = function () {
    function c() {
      h(this, c);
      this.providers = fa;
      this.getProviders();
    }

    f(c, [{
      key: "setShareCallback",
      value: function value(b) {
        this.providers = this.providers.map(function (c) {
          return c.setShareCallback(b);
        });
      }
    }, {
      key: "getProviders",
      value: function value() {
        return this.providers = this.providers.map(function (b) {
          return new b().getInstance();
        });
      }
    }, {
      key: "reNewAllInstance",
      value: function value() {
        this.providers = this.providers.map(function (b) {
          return b.reNewInstance();
        });
      }
    }]);
    return c;
  }();

  window._goodshare = new u();
})();